import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// material
import { Box, Grid, Card, Button, Typography, Stack } from "@mui/material";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { fDate } from "../../../utils/formatTime";
import { fCurrency, fNumber } from "../../../utils/formatNumber";
import { ShowError } from "../../../utils/loader";
import { CheckPerm } from "../../../utils/apis";
// ----------------------------------------------------------------------

SingleCard.propTypes = {
  purchase: PropTypes.object,
};

function SingleCard({ purchase }) {
  const { products, total, date, invoice, pid } = purchase;
  const productsArray = JSON.parse(products);
  const numProducts = productsArray.length;
  return (
    <Card
      variant="outlined"
      sx={{
        border: "0.4px solid",
        borderColor: "background.border",
        boxShadow:
          "4px 2px 124px rgba(46, 53, 58, 0.02), 0px 4px 124px rgba(46, 41, 78, 0.02)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0, pl: 2, pr: 1 }}>
        <Typography variant="subtitle2" noWrap>
          Invoice ID: <strong>{invoice}</strong>
        </Typography>
        <Typography variant="subtitle2" noWrap>
          {fNumber(numProducts)} {numProducts > 1 ? "products" : "product"}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            On {fDate(date)} <span>&nbsp;&nbsp;&middot;&nbsp;&nbsp;</span> at{" "}
            {fCurrency(total)}
          </Typography>
        </Box>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
          component={RouterLink}
          to={`${PATH_DASHBOARD.subpages.purchase}/${pid}`}
        >
          View
        </Button>
      </Box>
    </Card>
  );
}

Purchases.propTypes = {
  purchases: PropTypes.array.isRequired,
};

export default function Purchases({ purchases }) {
  const hasPermission = CheckPerm("view_purchases");
  return (
    <Box sx={{ mt: 5 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4" sx={{ mb: 3 }}>
          Purchases
        </Typography>
        {hasPermission && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            component={RouterLink}
            to={PATH_DASHBOARD.business.purchases}
          >
            View All
          </Button>
        )}
      </Stack>
      {purchases.length > 0 ? (
        <Grid container spacing={3}>
          {purchases.map((purchase, index) => (
            <Grid key={index} item xs={12} md={4}>
              <SingleCard purchase={purchase} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ShowError
          message={
            new Error(
              `This company does not have any purchase attached at the moment!`
            )
          }
        />
      )}
    </Box>
  );
}
